var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8229 6.67805C12.1147 6.67805 13.1619 5.63083 13.1619 4.33902C13.1619 3.04722 12.1147 2 10.8229 2C9.53111 2 8.48389 3.04722 8.48389 4.33902C8.48389 5.63083 9.53111 6.67805 10.8229 6.67805Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6918 7.24023L11.725 7.24101C13.5155 7.293 14.9249 8.78665 14.8729 10.5772V11.0762C14.8729 11.3257 14.7794 11.6064 14.4987 11.6064H9.97318C9.57029 10.3246 8.39095 9.37851 6.97234 9.33732L6.97119 9.33729C7.42636 8.13266 8.57926 7.26592 9.94539 7.24023H11.6918Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6608 9.52571C5.95261 9.52571 6.99983 8.47849 6.99983 7.18668C6.99983 5.89487 5.95261 4.84766 4.6608 4.84766C3.369 4.84766 2.32178 5.89487 2.32178 7.18668C2.32178 8.47849 3.369 9.52571 4.6608 9.52571Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56649 10.0906C5.55545 10.0903 5.5444 10.09 5.53336 10.0898H3.78691C1.99593 10.1235 0.57141 11.6027 0.605077 13.3937C0.605256 13.4047 0.605554 13.4158 0.605853 13.4268V13.9258C0.605853 14.1753 0.699391 14.456 0.980069 14.456H8.3402C8.62088 14.456 8.71442 14.1753 8.71442 13.9258V13.4268C8.76641 11.6363 7.35705 10.1426 5.56649 10.0906Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientUserIcon);
export default __webpack_public_path__ + "static/media/client-user-icon.c2ba8b42.svg";
export { ForwardRef as ReactComponent };